module.exports = __webpack_public_path__ + "ecfd8f098ef4a2a1702817e393c1a155.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-42.cur
// module id = 458
// module chunks = 0